// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"71dfdfe0","455":"c6004e93"}[chunkId] + ".chunk.js";
};